const initVideoControls = (root = document) => {
  if (!root) return;
  const rootEl = typeof root === 'string' ? document.querySelector(root) : root;
  if (!rootEl) return;

  rootEl.querySelectorAll('.media__custom-controls').forEach((customControls) => {
    const mediaContainer = customControls.closest('.media__container');
    if (!mediaContainer) return;
    const videos = mediaContainer.querySelectorAll('video');
    if (videos.length <= 0) return;

    customControls.addEventListener('click', () => {
      if (mediaContainer.classList.contains('playing')) {
        mediaContainer.classList.remove('playing');
        videos.forEach((video) => video.pause());
      } else {
        mediaContainer.classList.add('playing');
        videos.forEach((video) => video.play());
      }
    });
  });
};

export { initVideoControls };
